// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__3ubXI","consentsList":"PatientConsents_consentsList__3AMqe","consentsListEmpty":"PatientConsents_consentsListEmpty__1DsoG"};